// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwList from 'viewmodel/AwListViewModel';
import AwDefaultCell from 'viewmodel/AwDefaultCellViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desUpdateLibraryService', () => import('js/desUpdateLibraryService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "data": {
        "selectedTeams": null
    },
    "lifecycleHooks": {
        "onUpdate": {
            "observers": [
                "props.accsessionid",
                "props.collaborationspaceid",
                "props.libraryid"
            ]
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        }
    },
    "dataProviders": {
        "performSearchForTeams": {
            "action": "getTeams",
            "response": "{{data.searchResultsForTeams}}",
            "totalFound": "{{data.totalTeamsFound}}",
            "selectionModelMode": "multiple"
        }
    },
    "actions": {
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "revealTeams": {
            "actionType": "dataProvider",
            "method": "performSearchForTeams"
        },
        "getTeams": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}",
                            "searchInput": "{{data.eventData.searchInput}}"
                        },
                        "query": "query ListAllTeams($listTeamsInput: ListTeamsInput) {listAllTeams(listTeamsInput: $listTeamsInput)}",
                        "variables": {
                            "listTeamsInput": {
                                "searchOptions": {
                                    "skip": 0,
                                    "limit": 50,
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "searchResultsForTeams": "data.data.listAllTeams.filterObj",
                "totalTeamsFound": "data.data.listAllTeams.totalFound"
            },
            "events": {
                "success": [
                    {
                        "name": "searchTeamsResultsSuccess",
                        "condition": "searchTeamsResults.hasError === false",
                        "eventData": {
                            "eventName": "searchTeamsResultsSuccess",
                            "eventData": "{{searchResultsForTeams}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "clearSeachBox": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "clearSeachBoxEvent"
                    }
                ]
            }
        },
        "storeTeams": {
            "actionType": "JSFunction",
            "method": "storeTeamsData",
            "inputData": {
                "data": "{{data}}",
                "selectedTeams": "{{parameters.eventData}}"
            },
            "outputData": {
                "selectedObjects": "selectedAllTeams"
            },
            "events": {
                "success": [
                    {
                        "name": "selectedTeamsSuccess",
                        "eventData": {
                            "eventData": "{{selectedObjects}}"
                        }
                    }
                ]
            },
            "deps": "js/desUpdateLibraryService"
        }
    },
    "onEvent": [
        {
            "eventId": "searchInitiated",
            "action": "revealTeams",
            "cacheEventData": true
        },
        {
            "eventId": "performSearchForTeams.selectionChangeEvent",
            "cacheEventData": true,
            "action": "storeTeams",
            "inputArgs": {
                "eventName": "performSearchForTeams.selectionChangeEvent",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "selectedTeamsSuccess",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "selectedTeamsSuccess",
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "_viewModelId": "DesShareLibrarySearchResultsForTeams",
    "_uniqueViewModelId": "DesShareLibrarySearchResultsForTeams",
    "ctx": {}
};

    /*
    <aw-list dataprovider="data.dataProviders.performSearchForTeams">
    <aw-default-cell vmo="item"></aw-default-cell>
</aw-list>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwList dataprovider={dataProviders.performSearchForTeams} showDropArea={null} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>        <AwDefaultCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
        </AwDefaultCell></> } }
    </AwList>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;